const SELECTORS = {
  controls: "[data-bestseller-controls]",
  controlButton: "[data-bestseller-control]",
  wrapper: "[data-bestseller-grid]",
  grid: ".shop-items-products-grid",
  item: ".shop-item",
};

const initWheelScrolling = () => {
  const grids = document.querySelectorAll(SELECTORS.grid);
  grids.forEach((grid) => {
    grid.addEventListener(
      "wheel",
      (e) => {
        if (window.quickShopOpen) {
          return; // let normal page scroll happen
        }
        if (e.deltaY !== 0) {
          const isAtStart = grid.scrollLeft === 0;
          const isAtEnd =
            grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;

          const scrollingLeft = e.deltaY < 0;
          const scrollingRight = e.deltaY > 0;

          // Only prevent default if we're not at a boundary or scrolling away from it
          if ((!isAtStart || scrollingRight) && (!isAtEnd || scrollingLeft)) {
            e.preventDefault();
            grid.scrollBy({ left: e.deltaY, behavior: "instant" });
          }
        }
      },
      { passive: false },
    );
  });
};

const escapeId = (value) => {
  if (typeof value !== "string") {
    value = String(value);
  }
  if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
    return CSS.escape(value);
  }
  return value.replace(/[^\w-]/g, "\\$&");
};

const getGridForControls = (controlsEl) => {
  const section = controlsEl.closest(".section-bestseller");
  const targetId = controlsEl.dataset.bestsellerControls;
  if (!targetId) return null;

  const scope = section || document;
  const wrapper = scope.querySelector(
    `${SELECTORS.wrapper}[data-bestseller-grid="${escapeId(targetId)}"]`,
  );
  if (!wrapper) return null;

  return wrapper.querySelector(SELECTORS.grid);
};

const scrollAmount = (grid) => {
  const styles = getComputedStyle(grid);
  const gapValue =
    styles.columnGap || styles.getPropertyValue("grid-column-gap");
  let gap = parseFloat(gapValue);
  if (Number.isNaN(gap)) gap = 0;

  const firstItem =
    grid.querySelector(".shop-item--normal") ||
    grid.querySelector(SELECTORS.item);
  let columnWidth = firstItem ? firstItem.getBoundingClientRect().width : 0;
  if (!columnWidth) {
    columnWidth = parseFloat(
      styles.getPropertyValue("--bestseller-column-width"),
    );
  }
  if (Number.isNaN(columnWidth) || columnWidth <= 0) {
    columnWidth = grid.clientWidth;
  }

  return columnWidth + gap;
};

const handleControlClick = (event) => {
  const button = event.currentTarget;
  const controls = button.closest(SELECTORS.controls);
  if (!controls) return;

  const grid = getGridForControls(controls);
  if (!grid) return;

  const direction = button.dataset.bestsellerControl;
  const offset = scrollAmount(grid) * (direction === "next" ? 1 : -1);
  grid.scrollBy({ left: offset, behavior: "smooth" });
};

const initBestsellerControls = () => {
  initWheelScrolling();
  const controllers = document.querySelectorAll(SELECTORS.controls);
  controllers.forEach((controller) => {
    const buttons = controller.querySelectorAll(SELECTORS.controlButton);
    buttons.forEach((button) => {
      button.addEventListener("click", handleControlClick);
    });
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBestsellerControls);
} else {
  initBestsellerControls();
}
